import * as focusTrap from "focus-trap";

const openMobileMenu = (mobileMenu, hamburger, trap) => {
    mobileMenu.classList.add("r-is-opened");
    hamburger.querySelector(".ham").classList.add("ham-active");
    document.querySelector(".main").classList.add("main-overlay");
    document.body.style.overflow = "hidden";
    document.querySelector('.main').style.overflowX = "hidden";
    trap.activate();
    trap.unpause();
};

const closeMobileMenu = (mobileMenu, hamburger, trap) => {
    mobileMenu.classList.remove("r-is-opened");
    hamburger.querySelector(".ham").classList.remove("ham-active");
    document.querySelector(".main").classList.remove("main-overlay");
    document.body.style.overflow = "auto";
    document.querySelector('.main').style.overflowX = "";
    trap.deactivate();
};

const handleMobileItemClick = (e) => {
    e.stopPropagation();
    const submenu =
        e.currentTarget.parentElement.querySelector(".r-mobile-submenu");
    if (!submenu) return;
    e.currentTarget.setAttribute("aria-expanded", "true");
    submenu.classList.add("r-mobile-submenu--opened");
    submenu.setAttribute("aria-hidden", "false");
};

const handleGoBackClick = (e) => {
    e.stopPropagation();
    const parent = e.currentTarget.parentElement.parentElement; // ul
    parent.classList.remove("r-mobile-submenu--opened");
    parent.setAttribute("aria-hidden", "false");
    parent.previousElementSibling.setAttribute("aria-expanded", "false"); // button
};

const initMobileMenu = () => {
    const hamburger = document.querySelector(".r-mobile-menu__hamburger");
    const hamburgerWrapper = document.querySelector(
        ".r-mobile-menu__hamburger-wrapper"
    );
    const mobileMenu = document.querySelector(".r-mobile-menu__wrapper");

    if (!mobileMenu || !hamburger) return;

    const trap = focusTrap.createFocusTrap([mobileMenu, hamburgerWrapper], {
        allowOutsideClick: (e) => {
            if (!e.target.closest(".r-mobile-menu__wrapper")) {
                closeMobileMenu(mobileMenu, hamburger, trap);
                return true;
            }
            return false;
        },
        escapeDeactivates: false,
        clickOutsideDeactivates: false,
        initialFocus: mobileMenu,
    });

    const items = mobileMenu.querySelectorAll(".r-mobile-menu__item-button");

    hamburger.addEventListener("click", () => {
        if (mobileMenu.classList.contains("r-is-opened")) {
            closeMobileMenu(mobileMenu, hamburger, trap);
        } else {
            openMobileMenu(mobileMenu, hamburger, trap);
        }
    });

    items.forEach((item) => {
        item.addEventListener("click", (e) => handleMobileItemClick(e));

        const goBackButtons = mobileMenu.querySelectorAll(
            ".r-mobile-menu__item--back"
        );

        goBackButtons.forEach((item) => {
            item.addEventListener("click", (e) => handleGoBackClick(e));
        });
    });

    window.addEventListener("resize", () => {
        if (
            window.innerWidth > 1280 &&
            mobileMenu.classList.contains("r-is-opened")
        ) {
            closeMobileMenu(mobileMenu, hamburger, trap);
        }
    });
};

const initDesktopMenu = () => {
    const menu = document.querySelector(".r-menu");
    if (!menu) return;

    const items = menu.querySelectorAll(".r-menu__item.r-has-children");

    items.forEach((item) => {
        item.addEventListener("mouseenter", () => {
            document.querySelector(".main").classList.add("main-overlay");
        });
        item.addEventListener("mouseleave", () => {
            document.querySelector(".main").classList.remove("main-overlay");
        });
    });
};

const navigationRedesign = () => {
    initMobileMenu();
    initDesktopMenu();
};

export default navigationRedesign;
